const items = [
  {
    menu: {
      header: 'Latest Articles',
      description: 'The latest news, tips & advice from Policygenius.',
      link: 'https://www.policygenius.com/blog/',
      path: '/blog/',
      activeName: 'latest-magazine',
      tag: '',
    },
    intro: {
      textType: 'latest',
      link: 'https://www.policygenius.com/blog/',
    },
  },
  {
    menu: {
      header: 'Money',
      description: 'Advice, tips & tricks for keeping your financial life on point.',
      link: 'https://www.policygenius.com/blog/tag/money/',
      path: '/blog/tag/money/',
      activeName: 'money-magazine',
      tag: 'money',
    },
    intro: {
      textType: 'money',
      link: 'https://www.policygenius.com/blog/tag/money/',
    },
  },
  {
    menu: {
      header: 'Tech',
      description: 'Apps & tech to juice your investing, saving and budgeting.',
      link: 'https://www.policygenius.com/blog/tag/technology/',
      path: '/blog/tag/technology/',
      activeName: 'tech-magazine',
      tag: 'technology',
    },
    intro: {
      textType: 'tech',
      link: 'https://www.policygenius.com/blog/tag/technology/',
    },
  },
  {
    menu: {
      header: 'How-Tos',
      description: 'Explainers that make complex personal finance simple.',
      link: 'https://www.policygenius.com/blog/tag/how-tos/',
      path: '/blog/tag/how-tos/',
      activeName: 'how-tos-magazine',
      tag: 'how-tos',
    },
    intro: {
      textType: 'how-tos',
      link: 'https://www.policygenius.com/blog/tag/how-tos/',
    },
  },
  {
    menu: {
      header: 'Interviews',
      description: 'Real-life geniuses share deep money thoughts (& more).',
      link: 'https://www.policygenius.com/blog/tag/interviews/',
      path: '/blog/tag/interviews/',
      activeName: 'interviews-magazine',
      tag: 'interviews',
    },
    intro: {
      textType: 'interviews',
      link: 'https://www.policygenius.com/blog/tag/interviews/',
    },
  },
  {
    menu: {
      header: 'News',
      description: 'Personal finance news & updates, because cash rules everything around you.',
      link: 'https://www.policygenius.com/blog/tag/news/',
      path: '/blog/tag/news/',
      activeName: 'news-magazine',
      tag: 'news',
    },
    intro: {
      textType: 'news',
      link: 'https://www.policygenius.com/blog/tag/news/',
    },
  },
];

export default items;



// WEBPACK FOOTER //
// ../src/templates/MainNav/data/magazineItems.js